import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
	{
		path: '',
		component: () => import('@/views/tipologieservizio/Tipologieservizio.vue'),
		meta: {
			title: 'tipologieservizio',
			acl: 'section.tipologieservizio'
		}
	}
];

export default routes;